import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EnvironmentService, ExternalLinksService, LocalizationService, PersistenceService } from 'pg-lib';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    title = 'experience-finder';

    constructor(private environmentService:EnvironmentService, private externalLinksService:ExternalLinksService, private localizationService:LocalizationService, private persistenceService:PersistenceService, private route:ActivatedRoute) {}

    isWeb = false;

    isInIframe = false;

    isSwitchingLanguage = false;

    needConsent = false;

    ngOnInit(): void {
        this.isWeb = this.environmentService.environment.AppMode == 'web'

        if(this.environmentService.environment.AppMode == 'kiosk') {
            this.externalLinksService.setExternalLinkHandler((url:string) => {
                this.openLinkInIframe(url);
            })   
        }

        if(this.environmentService.externalParameters.iframe == 'true' || this.environmentService.externalParameters.iframekiosk == 'true') {
            this.isInIframe = true;
        }

        this.needConsent = this.persistenceService.needConsent && !this.isInIframe;

        this._checkExternalLanguage().then(() => {
            this.localizationService.currentLanguageChange.subscribe((langId) => {
                this.isSwitchingLanguage = true;

                setTimeout(() => {
                    this.isSwitchingLanguage = false;
                }, 200)
            })
        })
    }

    private async _checkExternalLanguage() {
        let _language = this.route.snapshot.queryParams.language;
        if(_language != null) await this.localizationService.setLanguage(_language);
    }

    externalLinkUrl:string = null;
    
    openLinkInIframe(url:string) {
        this.externalLinkUrl = url;
    }

    isUnderMaintenance() {
        return this.environmentService.getTimeUntilManteinance() <= 0;
    }
}
